import { createSelector } from "reselect";

export const rolesSelector = createSelector(
    state => state.services.roles,
    state => state
);